import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
	name: 'dateFilter'
})
export class DateFilterPipe implements PipeTransform {
	transform(items: Array<any>, startDate: string, endDate: string): Array<any> {
		console.log(moment.utc(startDate).format());
		if (!items) {
			return [];
		}
		if (!startDate || !endDate) {
			return items;
		}
		console.log('StartDate', startDate);
		console.log('endDate', endDate);

		const po = items.filter(item => {
			console.log('Format', moment.utc(startDate).format(), moment.utc(item.batchStartDate).format(), moment.utc(endDate).format(), moment.utc(item.batchEndDate).format());
			return moment.utc(startDate).format() >= moment.utc(item.batchStartDate).format() && moment.utc(endDate).format() <= moment.utc(item.batchEndDate).format();
		});
		console.log('po', po);
		return po;
	}
}
